import BaseScene from './BaseScene';
// Configurations
import GameOptions from '../utils/GameOptions';

export class PreloadScene extends BaseScene {
	progressBar;
	progressBox;
	textLoading;

	constructor() {
		super({ key: 'PreloadScene' });
	}

	preload() {
		// create preloader
		this.progressBar = this.add.graphics();
		this.progressBox = this.add.graphics();
		this.progressBar.depth = 20;
		this.progressBox.depth = 19;
		this.textLoading = this.add.bitmapText(this.game.config.width / 2 - 50, this.game.config.height / 2 - 50, 'gameFont', 'Loading', 41, 1);

		this.load.on('progress', value => {
			this.progressBox.clear();
			this.progressBox.fillStyle(0x222222, 1);
			this.progressBox.fillRect(this.game.config.width / 2 - 10 - 160, this.game.config.height / 2 - 10, 320, 50);
			//console.log(value);
			this.progressBar.clear();
			this.progressBar.fillStyle(0xffea31, 1);
			this.progressBar.fillRect(this.game.config.width / 2 - 160, this.game.config.height / 2, 300 * value, 30);
		});

		this.load.on('fileprogress', file => {
			//console.log('fileprogress: ' + file.src);
		});

		this.load.on('complete', () => {
			//console.log('complete');
			this.progressBar.destroy();
			this.progressBox.destroy();
			this.textLoading.destroy();
			this.scene.start('SlotScene');
		});

		// 1) loading png images, sprite sheets
		GameOptions.sprites.forEach(s => {
			if (s.fileName != null) {
				if (this.textures.exists(s.name)) this.textures.remove(s.name);
				this.load.image(s.name, 'images/' + s.fileName);
			}
		});
		// 2 load png textures from png folder
		GameOptions.symbols.forEach(s => {
			if (s.fileName != null) {
				if (this.textures.exists(s.name)) this.textures.remove(s.name);
				this.load.image(s.name, 'images/Symbols/' + s.fileName);
			}
		});

		GameOptions.symbols.forEach(s => {
			if (s.fileNameBlurred != null) {
				if (this.textures.exists(s.name + 'Blurred')) this.textures.remove(s.name + 'Blurred');
				this.load.image(s.name + 'Blurred', 'images/SymbolsBlurred/' + s.fileNameBlurred);
			}
		});
		GameOptions.symbols.forEach(s => {
			if (s.animation != null) {
				if (this.textures.exists(s.name + 'Sheet')) this.textures.remove(s.name + 'Sheet');
				this.load.spritesheet(s.name + 'Sheet', 'images/SymbolsSheet/' + s.animation, {
					frameWidth: GameOptions.frameWidth,
					frameHeight: GameOptions.frameHeight
				});
			}
		});

		this.load.spritesheet('coinspin', 'images/SymbolsSheet/CoinSheet.png', { frameWidth: 132, frameHeight: 132 });

		// 3) loading sounds
		GameOptions.sounds.forEach(s => {
			const sounds = s.files.map(sounds => {
				return `sounds/${sounds}`;
			});
			this.load.audio(s.name, sounds);
		});
	}
}
